import { Box, SvgIconProps, Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { ControlZoneSource, ZONE_CONFIG, ZONE_KEYS, ZONE_LABELS } from 'domain/shared/newProject';
import { normalizeControlZone } from './utils';

type ControlsZoneProps = {
  zone?: ControlZoneSource;
};

const ControlsZone = ({ zone }: ControlsZoneProps) => {
  const normalizedZone = normalizeControlZone(zone) ?? ZONE_KEYS.SAFE;
  const config = ZONE_CONFIG[normalizedZone];
  const label = ZONE_LABELS[normalizedZone];

  return (
    <Box display="flex" flexDirection="row" gap={1} alignItems="center">
      <CircleIcon color={config.color as SvgIconProps['color']} sx={{ fontSize: '1.2rem' }} />
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
    </Box>
  );
};

export default ControlsZone;
